// extracted by mini-css-extract-plugin
export default {"card":"LicenseCard_card__kegrw","title":"LicenseCard_title__kdsPl","cardButtons":"LicenseCard_cardButtons__hl3M1","expirationDate":"LicenseCard_expirationDate__B-zto"};